/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconArrowRightAlt/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconArrowRightAlt({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconArrowRightAlt",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconArrowRightAlt.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-dRcWP': alignSelf,'--mt-2-dRcWP': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-dRcWP': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-dRcWP': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-dRcWP': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-dRcWP': opacity,'--w-10-dRcWP': typeof width === 'number' ? `${width}px` : width,'--h-11-dRcWP': typeof height === 'number' ? `${height}px` : height,'--a-7-dRcWP': isAnimated ? animation : "none",'--sd-8-dRcWP': isAnimated ? strokeDashoffset : 0,'--sd-9-dRcWP': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconArrowRightAlt.SvgPath"
  data-view-path={viewPath}
 d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"
 style={{'--f-12-dRcWP': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}